import { createFileRoute } from "@tanstack/react-router";
import { filterParam, optionParam, textParam } from "@/utils/searchParams";

// The overview's focus and filters live in the URL, so the dashboard's counts
// can link straight to the matching list, and opening a product and coming
// back lands on the list the reader was reading (Jira NAV-258).

/** Which part of the overview to show: the evaluations with a legal step
 *  under way, the started ones whose legal step is still to come, or the
 *  ones the business unit has not started. Unset shows every running
 *  evaluation. */
export const EVALUATION_FOCUSES = ["now", "soon", "unreleased"] as const;
export type EvaluationFocus = (typeof EVALUATION_FOCUSES)[number];

export type GroupLegalEvaluationsSearch = {
  focus?: EvaluationFocus;
  /** Tool name, as typed. */
  q?: string;
  /** One business unit id. */
  bu?: string;
  /** "Only mine": the evaluations with a step that names the reader. */
  mine?: boolean;
};

export function groupLegalEvaluationsSearch(
  search: Record<string, unknown>,
): GroupLegalEvaluationsSearch {
  return {
    focus: optionParam(EVALUATION_FOCUSES, search.focus),
    q: textParam(search.q),
    bu: filterParam(search.bu),
    // Only `true` is kept, so an unticked box leaves the address bare.
    mine: search.mine === true || search.mine === "true" ? true : undefined,
  };
}

export const Route = createFileRoute("/group-legal/evaluations")({
  validateSearch: groupLegalEvaluationsSearch,
});
